const getFileNameFromUrl = (url: string): string | null => {
  try {
    // Check if URL has proper protocol (https://)
    if (!url.startsWith('https://')) {
      return null; // Exclude URLs without proper protocols
    }

    const decodedUrl = decodeURIComponent(url);

    // Step 1: Try extracting from "id=" param if present
    const idMatch = decodedUrl.match(/id=([^&]+)/);
    if (idMatch && idMatch[1]) {
      const idPath = decodeURIComponent(idMatch[1]); // Additional decoding
      const parts = idPath.split("/");
      const fileName = parts[parts.length - 1];
      return fileName ? decodeURIComponent(fileName) : null; // Decode file name
    }

    // Step 2: Try extracting from "file=" param if present
    const urlObj = new URL(decodedUrl);
    const queryFileName = urlObj.searchParams.get("file");
    if (queryFileName) {
      return decodeURIComponent(queryFileName); // Decode the file name
    }

    // Step 3: Fallback — use the pathname from the URL
    const pathnameParts = urlObj.pathname.split("/");
    const fileName = pathnameParts[pathnameParts.length - 1];

    return fileName ? decodeURIComponent(fileName) : null; // Decode file name
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};
export default getFileNameFromUrl;